// https://cors-anywhere.herokuapp.com/
const environment = "dev"; //dev,prod
const constant = {
  // baseUrl: environment == "prod" ? "" : "http://apidev-malco.influx.co.in/",
  // username: environment == "prod" ? "" : "website.cinemaapp@injin.com",
  // password: environment == "prod" ? "8m#eGV*fJCeQgX/D7" : "c#++byQh73FPgmF^",
  today_deals: false,
  static_promotions: true,
  login: true,
  cancelOrder: true,
  giftCardText: "Gift Card",
  // locationsToShow: ["8146", "8863", "8857", "8859", "8875", "8877"],
  locationsToShow: ["9990"]
};

export default constant;
